/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import { snapping } from 'utils/ticket-utils';
import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';

import AnimationQueue from '@appLegacy/lib/ui/AnimationQueue';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import firebase from 'firebase/compat/app';

/************************************************
 *	Contains all the code related to interacting
 *	with the plan.
 *************************************************/
export default function activeLineHandling(scope) {
	const logger = LoggerServiceFactory.create('activeLineHandling');
	this.scope = scope;

	let startX;

	let element;
	let nubElement;
	let ghostElement;
	let ghostNub;
	let offset;
	let foundColumn;

	this.hold = function (event, currentElement) {
		//logger.log('evt', event, currentElement);
	};

	this.dragStart = function (event, currentElement) {
		if (!scope.planAccessCheck.isAdminSync) {
			return false;
		}
		if (scope.planAccessCheck.hasRestrictedAccessSync) {
			return false;
		}
		if (!scope.activeLine || scope.activeLine.$value === null) {
			return false;
		}

		element = $(currentElement);
		offset = parseInt(element.attr('offset')) / 2;

		ghostElement = element.clone();
		ghostElement.removeAttr('data-element-type display-line override-contents');
		ghostElement.addClass('transient');

		nubElement = $('.active-line-nub').parent().parent();
		ghostNub = nubElement.clone();
		ghostNub.addClass('transient');

		element.parent().append(ghostElement);
		nubElement.parent().append(ghostNub);

		startX = scope.activeLine.$value; // + offset;

		foundColumn = undefined;
	};

	this.drag = function (event, currentElement) {
		if (scope.planAccessCheck.hasRestrictedAccessSync) {
			return false;
		}

		let left = startX + event.deltaX / scope.hud.z;

		let al = startX + 12 * scope.hud.z;
		let max;
		if (!scope.pp.isInitialPeriod && scope.pp.range && scope.pp.range.endX !== null) {
			max = scope.pp.range.endX;
		}
		// if(scope.pp.promisePeriodNext){ var max = scope.pp.promisePeriodNext.endX; }
		// else if(scope.pp.promisePeriodCurrent){ var max = scope.pp.promisePeriodCurrent.endX; }
		if (!max) {
			max = -Infinity;
		}
		let max2 = -Infinity;

		//the performance... it hurts
		scope.planState.tickets.syncList.forEach((t) => {
			const right = t.getTheoreticalRightEdge();
			if (right <= al && right > max) {
				max = right;
			}
		});

		// scope.tickets.forEach(function (ticket) {
		// 	if (ticket.data.left + ticket.data.width <= al) {
		// 		if (ticket.data.left + ticket.data.width > max2) {
		// 			max2 = ticket.data.left + ticket.data.width;
		// 		}
		// 		if(ticket.data.actualFinish){
		// 			var x = scope.activeColumnService.dateMap(ticket.data.actualFinish);
		// 			if(x > max2){ max2 = x; }
		// 		}
		// 	}
		// });

		//abort if on active side
		if (left < max) {
			left = max;
		}

		let hit = snapping(left, [scope.activeColumnService.columns(), [startX], scope.pullColumns], 150, [
			function (item) {
				return item.origFinishX;
			},
			function (x) {
				return x;
			},
			function (item) {
				return item.finishX;
			},
		]);
		if (hit) {
			left = hit.loc;
			if (hit.loc !== hit.item) {
				foundColumn = hit.item;
			} else {
				foundColumn = undefined;
			}
		} else {
			left = scope.activeLine.$value;
		}

		scope.activeLine.$value = left;
		AnimationQueue(function () {
			element.css({ left: left * scope.hud.z + scope.hud.x + offset + 'px' });
			nubElement.css({ left: left * scope.hud.z + scope.hud.x + 'px' });
		});
	};

	this.dragEnd = function (event, currentElement) {
		if (scope.planAccessCheck.hasRestrictedAccessSync) {
			return false;
		}

		let activeLineDate = scope.activeLineDate.$value;

		ghostElement.remove();
		ghostNub.remove();
		$('.active-line-nub').parent().removeClass('transient');
		if (foundColumn) {
			logger.log('found column', foundColumn);
			logger.log('found column datas', foundColumn, foundColumn.activeDay, scope.activeLineDate.$value);
			if (Math.floor(startX) !== Math.floor(foundColumn.origFinishX)) {
				Logging.notice('Activating');
			}
			if (foundColumn.pullColumn || foundColumn.pullColumn === 0) {
				const planPath = fancyFirebaseGetters.getPlanPath(
					scope.legacyState.projectId,
					scope.legacyState.planId
				);
				fancyFirebaseReferencer
					.getLegacyRef<firebase.database.Reference>(planPath, scope.legacyState.projectId)
					.child('activatePullColumn')
					.set(foundColumn.pullColumn);
				let movedColumns = scope.pullColumns.length - foundColumn.pullColumn;
				analyticsEventsService.draggedActiveLine(
					activeLineDate,
					foundColumn.pullColumn,
					foundColumn.plannedFinish,
					movedColumns,
					scope.legacyState.planId
				);
				//logger.log('found pull');
			}
			//sets active side stuff
			else if (foundColumn.activeDay !== scope.activeLineDate.$value) {
				logger.log('active side stuff');
				let extra = { initiatedBy: 'systemOnActiveLineChange' };
				let state = scope.legacyRouting.oldStyleSnapshot();
				return scope.snapshots
					.takeSnapshot(state.projectId, state.planId, scope.you.userId, extra)
					.then(function () {
						logger.log('snapshot success');
						const planPath = fancyFirebaseGetters.getPlanPath(
							scope.legacyState.projectId,
							scope.legacyState.planId
						);
						fancyFirebaseReferencer
							.getLegacyRef<firebase.database.Reference>(planPath, scope.legacyState.projectId)
							.update({
								activeLineDate: foundColumn.activeDay,
								activeLineX: Math.round(foundColumn.origFinishX),
							});
					});
			}
		}
	};
}
